import React from 'react'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import { staticContent } from '@src/routes'
import { Typography, Box } from '@material-ui/core/'
import MuiLink from '@material-ui/core/Link'
import { Link } from '@src/components/Link'
import { useUserSession } from '@utils/useUserSession'
import { FormattedMessage } from 'react-intl'
import messages from '@src/routes/ScanNow/messages'
import { Container } from '@material-ui/core'

const ScanNowOffline = () => {
  const {
    userSession: { language, country },
  } = useUserSession()

  return (
    <DefaultLayout spacing={LayoutSpacingOptions.SM}>
      <Container>
        <Typography variant="h1" component="h1">
          <FormattedMessage id="SCAN_NOW" defaultMessage="Scan Now" />
        </Typography>
        <Box mt={4} mb={4}>
          <Typography variant="h3" component="h3">
            <FormattedMessage {...messages.SCAN_NOW_IS_CURRENTLY_OFFLINE} />
          </Typography>
        </Box>
        <FormattedMessage
          {...messages.SCAN_NOW_OFFLINE_INFO}
          values={{
            SmartLabelPage: (
              <Link
                {...staticContent.index({
                  path: '/support/smart-label',
                  language,
                  country,
                })}
                passHref
              >
                <MuiLink target="_blank">
                  <FormattedMessage {...messages.SMART_LABEL_PAGE} />
                </MuiLink>
              </Link>
            ),
          }}
        />
      </Container>
    </DefaultLayout>
  )
}

export default ScanNowOffline
